export function subscribeLocalStorage(callback) {
  if (callback) {
    window.addEventListener('storage', e => {
      if (e.key === 'uploadListChanged') {
        callback();
      }
    });
  }
}

export function updateUploadList() {
  window.localStorage.setItem('uploadListChanged', new Date());
}

export function aiReportLocalStorage(callback) {
  if (callback) {
    window.addEventListener('storage', e => {
      if (e.key === 'updatedAiReport') {
        callback();
      }
    });
  }
}

export function intelligentReviewStorage(callback) {
  if (callback) {
    window.addEventListener('storage', e => {
      if (e.key === 'updateIntelligentReview') {
        callback();
      }
    });
  }
}

export function changeMenuTaskFlagUpdate(callback) {
  if (callback) {
    window.addEventListener('storage', e => {
      if (e.key === 'changeMenuTaskFlag') {
        callback();
      }
    });
  }
}
export function logoutStorage(callback) {
  if (callback) {
    window.addEventListener('storage', e => {
      if (e.key === 'logoutHappend') callback();
    });
  }
}
